module.exports = __webpack_public_path__ + "img/moto.68822d09.png";